var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: _vm.titulo } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-layout",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isVerDetalle,
                                  expression: "!isVerDetalle"
                                }
                              ],
                              attrs: { row: "", wrap: "" }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md12: "" } },
                                [
                                  _c("v-switch", {
                                    attrs: {
                                      label: _vm.formFields.estado.label,
                                      id: _vm.formFields.estado.id,
                                      color: "yellow",
                                      readonly: _vm.isVerDetalle,
                                      hint: _vm.hint,
                                      "persistent-hint": true
                                    },
                                    on: { change: _vm.cambio },
                                    model: {
                                      value: _vm.estado,
                                      callback: function($$v) {
                                        _vm.estado = $$v
                                      },
                                      expression: "estado"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm12: "", md12: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "`required`"
                                      }
                                    ],
                                    attrs: {
                                      label: _vm.formFields.nombre.label,
                                      "data-vv-name": _vm.formFields.nombre.id,
                                      id: "txtNombre",
                                      disabled: _vm.isVerDetalle,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.nombre.id
                                      )
                                    },
                                    on: { change: _vm.handleNombre },
                                    model: {
                                      value: _vm.formFields.nombre.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.nombre,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.nombre.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md6: "" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      label: _vm.formFields.tipoZona.label,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.tipoZona.id
                                      ),
                                      "data-vv-name":
                                        _vm.formFields.tipoZona.id,
                                      items: _vm.lstTipoZonas,
                                      "item-text": "nombre",
                                      "item-value": "id"
                                    },
                                    on: { change: _vm.handleTipoZonaChange },
                                    model: {
                                      value: _vm.formFields.tipoZona.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.tipoZona,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.tipoZona.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md6: "" } },
                                [
                                  _c("Buscador", {
                                    attrs: {
                                      filter:
                                        _vm.gridApiZonasRutas &&
                                        _vm.gridApiZonasRutas.setQuickFilter.bind(
                                          _vm.gridApiZonasRutas
                                        )
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c(
                                "v-card",
                                [
                                  _vm.isVerDetalle
                                    ? _c("MantenedorGridVerDetalle", {
                                        attrs: {
                                          "grid-options":
                                            _vm.gridOptionsZonasRutas,
                                          "row-data": _vm.lsZonas
                                        }
                                      })
                                    : _c("AsociacionGrid", {
                                        attrs: {
                                          "grid-options":
                                            _vm.gridOptionsZonasRutas,
                                          esEditar: _vm.modoEditar,
                                          headerCheckbox: _vm.modoEditar
                                        }
                                      })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c("br")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }